/* global gform */
import FrontEndHandler from './frontend-handler';

const init = () => {
	gform.extensions = gform.extensions || {};
	gform.extensions.styles = gform.extensions.styles || {};
	gform.extensions.styles.gravityformssquare = gform.extensions.styles.gravityformssquare || {};

	window.GFSquare = ( args ) => {
		window.SquareFrontEndHandler = new FrontEndHandler( args );
	};
};

export default init;
